module.exports = __webpack_public_path__ + "img/tool1.1c661d01.jpg";